module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/marker-69bda.svg";